const ApplicantsActionTypes = {
  START_FETCH_APPLICANTS: 'START_FETCH_APPLICANTS',
  FETCH_APPLICANTS_SUCCESS: 'FETCH_APPLICANTS_SUCCESS',
  FETCH_APPLICANTS_FAILURE: 'FETCH_APPLICANTS_FAILURE',

  START_FETCH_KEEP_IN_VIEW_APPLICANTS: 'START_FETCH_KEEP_IN_VIEW_APPLICANTS',
  FETCH_KEEP_IN_VIEW_APPLICANTS_SUCCESS:
    'FETCH_KEEP_IN_VIEW_APPLICANTS_SUCCESS',
  FETCH_KEEP_IN_VIEW_APPLICANTS_FAILURE:
    'FETCH_KEEP_IN_VIEW_APPLICANTS_FAILURE',

  START_FETCH_ADMITTED_APPLICANTS: 'START_FETCH_ADMITTED_APPLICANTS',
  FETCH_ADMITTED_APPLICANTS_SUCCESS: 'FETCH_ADMITTED_APPLICANTS_SUCCESS',
  FETCH_ADMITTED_APPLICANTS_FAILURE: 'FETCH_ADMITTED_APPLICANTS_FAILURE',

  START_FETCH_DECLINED_APPLICANTS: 'START_FETCH_DECLINED_APPLICANTS',
  FETCH_DECLINED_APPLICANTS_SUCCESS: 'FETCH_DECLINED_APPLICANTS_SUCCESS',
  FETCH_DECLINED_APPLICANTS_FAILURE: 'FETCH_DECLINED_APPLICANTS_FAILURE',

  START_FETCH_APPLICANTS_FORM: 'START_FETCH_APPLICANTS_FORM',
  FETCH_APPLICANTS_FORM_SUCCESS: 'FETCH_APPLICANTS_FORM_SUCCESS',
  FETCH_APPLICANTS_FORM_FAILURE: 'FETCH_APPLICANTS_FORM_FAILURE',

  START_FETCH_FORM_SCHEMA: 'START_FETCH_FORM_SCHEMA',
  FETCH_FORM_SCHEMA_SUCCESS: 'FETCH_FORM_SCHEMA_SUCCESS',
  FETCH_FORM_SCHEMA_FAILURE: 'FETCH_FORM_SCHEMA_FAILURE',

  PROCESS_APPLICANT_STAGE: 'PROCESS_APPLICANT_STAGE',
  PROCESS_SUCCESSFUL_STAGE_UPDATE: 'PROCESS_SUCCESSFUL_STAGE_UPDATE',
  PROCESS_FAILED_STAGE_UPDATE: 'PROCESS_FAILED_STAGE_UPDATE',

  BATCH_PROCESS_APPLICANT_STAGE: 'BATCH_PROCESS_APPLICANT_STAGE',
  BATCH_PROCESS_SUCCESSFUL_STAGE_UPDATE: 'BATCH_PROCESS_SUCCESSFUL_STAGE_UPDATE',
  BATCH_PROCESS_FAILED_STAGE_UPDATE: 'BATCH_PROCESS_FAILED_STAGE_UPDATE',

  NOTIFY_APPLICANT_START: 'NOTIFY_APPLICANT_START',
  NOTIFY_APPLICANT_SUCCESS: 'NOTIFY_APPLICANT_SUCCESS',
  NOTIFY_APPLICANT_FAILURE: 'NOTIFY_APPLICANT_FAILURE',

  START_FETCH_APPLICANT_APPLICATION: 'START_FETCH_APPLICANT_APPLICATION',
  START_FETCH_APPLICANT_APPLICATION_SUCCESS:
    'START_FETCH_APPLICANT_APPLICATION_SUCCESS',
  START_FETCH_APPLICANT_APPLICATION_FAILURE:
    'START_FETCH_APPLICANT_APPLICATION_FAILURE',

  SEARCH_APPLICANTS_APPLICATION_START: 'SEARCH_APPLICANTS_APPLICATION_START',

  EXPORT_APPLICANTS_DATA_START: 'EXPORT_APPLICANTS_DATA_START',
  EXPORT_APPLICANTS_DATA_SUCCESS: 'EXPORT_APPLICANTS_DATA_SUCCESS',
  EXPORT_APPLICANTS_DATA_FAILURE: 'EXPORT_APPLICANTS_DATA_FAILURE',

  SEND_EMAIL_START: 'SEND_EMAIL_START',
  SEND_EMAIL_SUCCESS: 'SEND_EMAIL_SUCCESS',
  SEND_EMAIL_FAILURE: 'SEND_EMAIL_FAILURE',

  FETCH_PRELOADED_STATS_START: 'FETCH_PRELOADED_STATS_START',
  FETCH_PRELOADED_STATS_SUCCESS: 'FETCH_PRELOADED_STATS_SUCCESS',
  FETCH_PRELOADED_STATS_FAILURE: 'FETCH_PRELOADED_STATS_FAILURE',

  FETCH_EMAIL_START: 'FETCH_EMAIL_START',
  FETCH_EMAIL_SUCCESS: 'FETCH_EMAIL_SUCCESS',
  FETCH_EMAIL_FAILURE: 'FETCH_EMAIL_FAILURE',

  FETCH_APPLICANT_TRANSACTIONS_START: 'FETCH_APPLICANT_TRANSACTIONS_START',
  FETCH_APPLICANT_TRANSACTIONS_SUCCESS: 'FETCH_APPLICANT_TRANSACTIONS_SUCCESS',
  FETCH_APPLICANT_TRANSACTIONS_FAILURE: 'FETCH_APPLICANT_TRANSACTIONS_FAILURE',
};

export default ApplicantsActionTypes;
